import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { Option } from 'components/formComponents/Base/Dropdown';
import { PartyApplicationFullTexts } from '../../types/PartyApplication/PartyApplicationTexts';
import { PartyApplicationSubmitDto } from '../../types/PartyApplication/PartyApplicationSubmitDto';
import { ImportTerminatedEmployeesResponse } from './steps/Form/ReportDismissedSection/types';

export interface PartyApplicationSubmitResponse {
  success: boolean;
  processingId?: string;
}

export interface ExistingAutomatedBankruptcyIncidentLookupResult {
  incidentId?: string;
  hasExistingIncident: boolean;
}

export interface BankruptcyContactFlowSubmitRequest {
  incidentId: string;
  unionRole: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export const partyApplicationApi = createApi({
  reducerPath: 'partyApplicationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${cmsApiConfig.url}/partyApplication`,
  }),
  endpoints: (builder) => ({
    getPageTexts: builder.query<PartyApplicationFullTexts, void>({
      query: () => '/pageTexts',
    }),
    getUnions: builder.query<Option[], void>({
      query: () => '/unions',
    }),
    importTerminatedEmployees: builder.mutation<
      ImportTerminatedEmployeesResponse,
      FormData
    >({
      query: (body) => ({
        url: '/importTerminatedEmployees',
        method: 'POST',
        body,
      }),
    }),
    submitApplication: builder.mutation<
      PartyApplicationSubmitResponse,
      PartyApplicationSubmitDto
    >({
      query: (body) => ({
        url: '/submit',
        method: 'POST',
        body,
      }),
    }),
    getExistingAutomatedBankruptcyIncident: builder.query<
      ExistingAutomatedBankruptcyIncidentLookupResult,
      string
    >({
      query: (organisationNumber) => ({
        url: '/getExistingAutomatedBankruptcyIncident',
        params: {
          organisationNumber,
        },
      }),
    }),
    submitExistingAutomatedBankruptcyContact: builder.mutation<
      boolean,
      BankruptcyContactFlowSubmitRequest
    >({
      query: (body) => ({
        url: '/submitExistingAutomatedBankruptcyContact',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetPageTextsQuery,
  useLazyGetExistingAutomatedBankruptcyIncidentQuery,
  useGetUnionsQuery,
  useImportTerminatedEmployeesMutation,
  useSubmitExistingAutomatedBankruptcyContactMutation,
  useSubmitApplicationMutation,
} = partyApplicationApi;
